import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Check = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M9.55 14.9466l8.3674-8.3676c.2279-.2278.495-.3417.8015-.3417s.5738.114.8018.3417c.2278.228.3417.4985.3417.8113s-.1139.5833-.3417.8112l-9.169 9.1881c-.228.2278-.4953.3417-.8018.3417-.3065 0-.5737-.1139-.8017-.3417l-4.288-4.288c-.2278-.228-.3386-.4985-.3323-.8113.0064-.3128.1235-.5832.3513-.8112.228-.2279.4984-.3418.8112-.3418.3129 0 .5833.1139.8113.3418l3.4482 3.4675z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M9.55 14.9466l8.3674-8.3676c.2279-.2278.495-.3417.8015-.3417s.5738.114.8018.3417c.2278.228.3417.4985.3417.8113s-.1139.5833-.3417.8112l-9.169 9.1881c-.228.2278-.4953.3417-.8018.3417-.3065 0-.5737-.1139-.8017-.3417l-4.288-4.288c-.2278-.228-.3386-.4985-.3323-.8113.0064-.3128.1235-.5832.3513-.8112.228-.2279.4984-.3418.8112-.3418.3129 0 .5833.1139.8113.3418l3.4482 3.4675z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M9.55 14.9466l8.3674-8.3676c.2279-.2278.495-.3417.8015-.3417s.5738.114.8018.3417c.2278.228.3417.4985.3417.8113s-.1139.5833-.3417.8112l-9.169 9.1881c-.228.2278-.4953.3417-.8018.3417-.3065 0-.5737-.1139-.8017-.3417l-4.288-4.288c-.2278-.228-.3386-.4985-.3323-.8113.0064-.3128.1235-.5832.3513-.8112.228-.2279.4984-.3418.8112-.3418.3129 0 .5833.1139.8113.3418l3.4482 3.4675z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M9.55 14.9466l8.3674-8.3676c.2279-.2278.495-.3417.8015-.3417s.5738.114.8018.3417c.2278.228.3417.4985.3417.8113s-.1139.5833-.3417.8112l-9.169 9.1881c-.228.2278-.4953.3417-.8018.3417-.3065 0-.5737-.1139-.8017-.3417l-4.288-4.288c-.2278-.228-.3386-.4985-.3323-.8113.0064-.3128.1235-.5832.3513-.8112.228-.2279.4984-.3418.8112-.3418.3129 0 .5833.1139.8113.3418l3.4482 3.4675z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Check.displayName = "CheckIcon";

export { Check, Check as default };
